import React, { useEffect, useRef } from "react";
import { BsFacebook, BsInstagram, BsWhatsapp, BsTelephone } from "react-icons/bs";
import { HiOutlineMail, HiOutlineLocationMarker } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import kabelmarketlogo from "../assets/kabelmarketlogo.png";

const Footer = () => {
  const categories = useSelector((state) => state.category.data);
  const carouselRef = useRef(null);
  const { name = "all", category = "all" } = useParams();

  const getFilterUrl = (filter) => {
    const filterCategory = filter.category || category;
    const filterName = filter.name || name;
    return `/search/category/${filterCategory}/name/${filterName}`;
  };

  // Auto-scrolling category carousel effect
  useEffect(() => {
    if (!categories || categories.length <= 5) return;
    
    const carousel = carouselRef.current;
    if (!carousel) return;

    const scrollWidth = carousel.scrollWidth;
    let scrollPosition = 0;
    let direction = 1;
    
    const scroll = () => {
      // Change direction when reaching the end
      if (scrollPosition >= scrollWidth - carousel.offsetWidth) {
        direction = -1;
      } else if (scrollPosition <= 0) {
        direction = 1;
      }
      
      scrollPosition += 0.5 * direction;
      carousel.scrollLeft = scrollPosition;
    };

    const interval = setInterval(scroll, 30);
    return () => clearInterval(interval);
  }, [categories]);

  return (
    <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 pt-12 pb-8 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img
                className="h-16 w-auto object-contain"
                src={kabelmarketlogo}
                alt="kabelmarket.az"
              />
            </Link>
            <p className="text-gray-300 max-w-xs">
              Hər növ kabellərin satışı - Kabel Market Azərbaycanın ən böyük kabel təchizatçısıdır.
            </p>
            <div className="flex space-x-5">
              <a
                href="/"
                target="_blank"
                rel="noreferrer"
                className="text-gray-300 hover:text-yellow-400 transition-colors duration-300"
                aria-label="Facebook"
              >
                <BsFacebook className="h-6 w-6" />
              </a>
              <a
                href="https://www.instagram.com/kabelmarket.az/"
                target="_blank"
                rel="noreferrer"
                className="text-gray-300 hover:text-yellow-400 transition-colors duration-300"
                aria-label="Instagram"
              >
                <BsInstagram className="h-6 w-6" />
              </a>
              <a
                href="https://wa.me/994504071417"
                target="_blank"
                rel="noreferrer"
                className="text-gray-300 hover:text-yellow-400 transition-colors duration-300"
                aria-label="WhatsApp"
              >
                <BsWhatsapp className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Contact Information */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold tracking-wide">Əlaqə</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <BsTelephone className="h-5 w-5 text-yellow-400 flex-shrink-0 mt-1" />
                <a href="tel:+994504071417" className="text-gray-300 hover:text-white transition-colors duration-300">
                  (+994) 50 407 14 17
                </a>
              </li>
              <li className="flex items-start gap-3">
                <HiOutlineMail className="h-5 w-5 text-yellow-400 flex-shrink-0 mt-1" />
                <a href="mailto:info@kabelmarket.az" className="text-gray-300 hover:text-white transition-colors duration-300">
                  info@kabelmarket.az
                </a>
              </li>
              <li className="flex items-start gap-3">
                <HiOutlineLocationMarker className="h-5 w-5 text-yellow-400 flex-shrink-0 mt-1" />
                <a 
                  href="https://maps.google.com/maps?q=40.5865747,49.6330819" 
                  target="_blank"
                  rel="noreferrer"
                  className="text-gray-300 hover:text-white transition-colors duration-300"
                >
                  Bakı şəh., Sabunçu ray., 1-ci Zabrat qəs., 18 Oktyabr küçəsi, 65
                </a>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold tracking-wide">Məhsullar</h3>
            <div className="relative">
              <div 
                ref={carouselRef}
                className="overflow-x-auto hide-scrollbar py-2 max-h-40"
              >
                <div className="grid grid-cols-1 gap-2">
                  {categories?.map((category) => (
                    <Link
                      to={getFilterUrl({ category: category?.title })}
                      key={category?._id}
                      className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 flex justify-between items-center"
                    >
                      <span>{category?.title}</span>
                      <span className="text-yellow-400 text-sm">
                        ({category?.productCount})
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
              <div className="absolute inset-x-0 bottom-0 h-6 bg-gradient-to-t from-gray-900 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Kabel Market. Bütün hüquqlar qorunur.
            </p>
            <div className="text-sm text-gray-400 flex flex-wrap items-center justify-center gap-1">
              
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
